var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 16.4163C12.3749 16.4163 15.9193 12.8719 15.9193 8.49967C15.9193 4.12742 12.3749 0.583008 8.0026 0.583008C3.63035 0.583008 0.0859375 4.12742 0.0859375 8.49967C0.0859375 12.8719 3.63035 16.4163 8.0026 16.4163ZM6.23468 6.80995C6.61315 7.02888 7.09743 6.89955 7.31636 6.52108C8.07399 5.42436 9.53849 6.88467 8.33776 7.59848C8.12193 7.72678 7.83969 7.94034 7.62501 8.20196C7.42174 8.44968 7.23505 8.79034 7.21309 9.20903C7.21029 9.23608 7.20886 9.26355 7.20886 9.29134C7.20886 9.72857 7.5633 10.083 8.00053 10.083C8.60399 10.083 8.71886 9.76242 8.83477 9.4389C8.90933 9.23079 8.98433 9.02147 9.1901 8.89551C9.84451 8.49491 10.3776 7.78537 10.3776 6.91634C10.3776 5.60466 9.31428 4.54134 8.0026 4.54134C7.12252 4.54134 6.35528 5.02044 5.94582 5.72827C5.72689 6.10673 5.85622 6.59102 6.23468 6.80995ZM7.20886 11.6663C7.20886 11.2291 7.5633 10.8747 8.00053 10.8747C8.43775 10.8747 8.7922 11.2291 8.7922 11.6663C8.7922 12.1036 8.43775 12.458 8.00053 12.458C7.5633 12.458 7.20886 12.1036 7.20886 11.6663Z",
    fill: "#393ABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBlueCircle);
export default __webpack_public_path__ + "static/media/question-blue-circle.caaeb5536546d89d1fb2cca9e37bf27b.svg";
export { ForwardRef as ReactComponent };